import { MaterialType } from '@mnd-frontend/graphql-schema';
import { Icons } from '@mnd-frontend/ui';

export const MaterialIcon = ({ type }: { type: MaterialType }) => {
  const mapping = {
    [MaterialType.BlogPost]: <Icons.Story $size="xxs" />,
    [MaterialType.Document]: <Icons.TextFile $size="xxs" />,
    [MaterialType.Event]: <Icons.Calendar $size="xxs" />,
    [MaterialType.Image]: <Icons.Image $size="xxs" />,
    [MaterialType.News]: <Icons.Story $size="xxs" />,
    [MaterialType.Pressrelease]: <Icons.Story $size="xxs" />,
    [MaterialType.Video]: <Icons.LearningVideo $size="xxs" />,
  };

  return mapping[type];
};
